import { render, staticRenderFns } from "./StudentPanel.vue?vue&type=template&id=41e483ac"
import script from "./StudentPanel.vue?vue&type=script&lang=js"
export * from "./StudentPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports